import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
const EditGroupComponent = loadable(
  () => import("../../components/CargoDeliveryCharge/EditGroup")
);
type Props = {
  id: string;
  closeModal: () => void;
};
const EditGroup = ({ id, closeModal }) => {
  const { refetch } = useGetHook({
    queryKey: [`group`],
    url: `${APIS.LOCATION}${id}/`,
    params: {},
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["group"],
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.LOCATION}${id}/`;
    let formData = {
      ...values,
      parent: null,
      type: "group",
      countries: values.countries?.map((item: any) => item.value),
      service: values?.service?.id ?? values?.service,
    };
    try {
      await mutateAsync({ url, formData, setError });
      closeModal();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <EditGroupComponent
        isLoading={isPatchLoading}
        refetch={refetch}
        handleEdit={handleEdit}
      />
    </>
  );
};
export default EditGroup;
